<div class="content">
  <!-- <div class="row">
    <div class="col-12">
      <div class="header-wrapper">
        <div class="company">
          {{data.COMPANY_NAME}}
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div class="row data-row">
    <div class="col-12">
      <label>Domains</label>
      <div class="value">{{data.DOMAINS}}</div>
    </div>
  </div> -->

  <div class="row data-row">
    <div class="col-12">
      <label>Notes</label>
      <div class="value notes">{{data.NOTES}}</div>
    </div>
  </div>

</div>
